import { render, staticRenderFns } from "./TagUsername.vue?vue&type=template&id=27550ee0&"
import script from "./TagUsername.vue?vue&type=script&lang=js&"
export * from "./TagUsername.vue?vue&type=script&lang=js&"
import style0 from "./TagUsername.vue?vue&type=style&index=0&id=27550ee0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports